import React from "react";
import Select from "react-select";
import { Tooltip } from "react-tooltip";
import { FaInfoCircle } from "react-icons/fa";
import "react-tooltip/dist/react-tooltip.css";
import { useTooltips } from "../../hooks/toolTips"; // adjust path as needed

const getTooltip = (tooltips, label, name) => {
  if (!Array.isArray(tooltips)) return "";
  const match = tooltips.find(
    (t) =>
      (label && t.Label?.toLowerCase() === label.toLowerCase()) ||
      (name && t.Name?.toLowerCase() === name.toLowerCase())
  );
  return match?.Tooltip && match.Tooltip !== "123" ? match.Tooltip : "";
};

export const SearchableSelect = ({
  label,
  name,
  value = "",
  options = [],
  onChange,
  disabled,
  required,
  isReport,
  tooltip,
  ...rest
}) => {
  const tooltips = useTooltips();
  const resolvedTooltip = (tooltip || getTooltip(tooltips, label?.replace(/:$/, ""), name))?.replace(/\n/g, "<br/>");

  const reactOptions = options.map((opt) => ({
    value: opt.value,
    label: opt.display_value,
  }));

  const selectedOption = reactOptions.find((opt) => opt.value === value) || null;

  if (isReport) {
    return (
      <p>
        {label}
        {required && "*"}: {selectedOption?.label || "None"}
      </p>
    );
  }

  return (
    <div className="form-group">
      <label htmlFor={name} style={{ display: "flex", alignItems: "center", gap: "6px" }}>
        {label}
        {required && "*"}
        {resolvedTooltip && (
          <>
            <span
              data-tooltip-id={`tooltip-${name}`}
              style={{ cursor: "pointer" }}
            >
              <FaInfoCircle size={14} color="#07b1b0" />
            </span>
            <Tooltip
              id={`tooltip-${name}`}
              place="right"
              className="custom-tooltip clickable-tooltip"
              openOnClick={true}
              clickable={true}
              globalCloseEvents={{ clickOutsideAnchor: true }}
            >
              <div className="tooltip-text" dangerouslySetInnerHTML={{ __html: resolvedTooltip }} />
            </Tooltip>
          </>
        )}
      </label>
      <Select
        inputId={name}
        name={name}
        value={selectedOption}
        onChange={(selected) => {
          onChange({ target: { name, value: selected?.value || "None" } });
        }}
        options={reactOptions}
        isDisabled={disabled}
        isSearchable
        placeholder="Select an option"
        {...rest}
      />
    </div>
  );
};
